import Model, { attr } from '@ember-data/model';

import type { APIData, DSSetup } from 'webapp-types';

import type { ForecastMethodology } from 'webapp/models-custom/forecast';

export default class RegressorMetricRecord extends Model {
	@attr('string') forecastId!: string;

	@attr('string') metricSetupKey!: string;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;

	@attr('object')
	methodology!: ForecastMethodology;
	@attr('number') correlation!: number | null;
	@attr('boolean', { defaultValue: true }) enabled!: boolean;
	@attr('object-or-null') statusObject!: APIData.Forecast.StatusObject | null;

	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('number') updated!: number;
}
